import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setMerchantModalData,
  setMerchantModalStatus,
  setSelectedMallSlug,
} from '../../../modules/explore/actions/creators'

import {
  setMerchants,
  setMalls,
} from '../../../modules/dashboard/actions/creators'

import {
  setPrimaryInfo,
  setAccountStatus,
  displayProfileModal,
  setFavoriteMalls,
  setTransportationMall,
} from '../../../modules/profile/actions/creators'

import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

const mapStateToProps = ({
  dashboard,
  auth,
  profile,
  loyalty,
  errors,
  explore,
}) => {
  const { accessToken, firebaseMessagingToken } = auth
  const {
    primaryInfo,
    advanceAccount,
    registrationToken,
    favoriteMalls,
  } = profile
  const { malls, merchants } = dashboard
  const {
    showMerchantModal,
    merchantModalData,
    merchantModalStatus,
    selectedMallSlug,
  } = explore

  const { loyaltyPoints, transactionsEarned, transactionsRedeemed } = loyalty
  const { errorList } = errors

  return {
    primaryInfo,
    advanceAccount,
    registrationToken,
    accessToken,
    malls,
    merchants,
    showMerchantModal,
    loyaltyPoints,
    transactionsEarned,
    transactionsRedeemed,
    errorList,
    favoriteMalls,
    merchantModalData,
    merchantModalStatus,
    selectedMallSlug,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMalls,
      setFavoriteMalls,
      setPrimaryInfo,
      setAccessToken,
      setAccountStatus,
      setLoyaltyPoints,
      setTransactionsEarned,
      setTransactionsRedeemed,
      setMerchantModalData,
      setMerchantModalStatus,
      displayProfileModal,
      setTransportationMall,
      setError,
      removeError,
      push,
      waitRenderServer,
      renderServer,
      setMerchants,
      setSelectedMallSlug,
      setFirebaseMessagingToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
